// Front-end helpers shared by the two tabs of /ato-plans (payment plans + tax paid):
// the API call, file → base64 for Claude reads, clipboard, and the ATO's payment details.
import { uprightJpegBytes } from './imageOrient';

export const API_URL = '/.netlify/functions/ato-plans-sb';
export const DOC_URL = '/.netlify/functions/ato-plans-doc-sb';
// The ATO's own short link to Government EasyPay (card payments). The service moved in
// 2025 and the old governmenteasypay.gov.au/payato now lands on a "we've moved" page, so
// link the ATO's redirect rather than wherever it points today. EasyPay can't be
// pre-filled: it asks for the PRN and the amount, which is why Pay copies the PRN first.
export const EASYPAY_URL = 'https://www.ato.gov.au/GovernmentEasypay';
// The ATO's BPAY biller code — the same for every ATO account; the PRN is the reference.
// As printed on VLL's payment-arrangement emails (24 Sep 2026). BPAY has no card fee.
export const BPAY_BILLER = '75556';
export const MAX_MB = 4; // base64 inflates ~33%; Netlify's function body limit is 6 MB

export const api = (action, payload = {}) =>
  fetch(API_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action, ...payload }) }).then((r) => r.json());

export const fmtDate = (iso) => (iso ? new Date(iso + 'T12:00').toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : '—');
export const fmtDay = (iso) => (iso ? new Date(iso + 'T12:00').toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' }) : '—');
export const fmtMoney = (n) => (n == null || n === '' ? '—' : (Number(n) || 0).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' }));

function arrayBufferToBase64(ab) {
  const bytes = new Uint8Array(ab);
  let bin = '';
  for (let i = 0; i < bytes.length; i += 0x8000) bin += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  return btoa(bin);
}
export async function fileToBase64(file) {
  if (file.type === 'application/pdf') return { base64: arrayBufferToBase64(await file.arrayBuffer()), contentType: 'application/pdf' };
  let contentType = 'image/jpeg';
  let ab = await uprightJpegBytes(file, 2000, 0.85);
  if (!ab) { ab = await file.arrayBuffer(); contentType = file.type || 'image/jpeg'; }
  return { base64: arrayBufferToBase64(ab), contentType };
}
export function checkFile(f, notify) {
  if (!f) return false;
  const ok = f.type.startsWith('image/') || f.type === 'application/pdf';
  if (!ok) { notify?.('Attach a photo, screenshot or PDF', 'error'); return false; }
  if (f.type === 'application/pdf' && f.size > MAX_MB * 1.4 * 1024 * 1024) { notify?.(`That PDF is too large (keep under ${MAX_MB} MB)`, 'error'); return false; }
  return true;
}

export async function copyText(text) {
  try { await navigator.clipboard.writeText(text); return true; }
  catch {
    const ta = document.createElement('textarea');
    ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    let ok = false; try { ok = document.execCommand('copy'); } catch { ok = false; }
    ta.remove(); return ok;
  }
}

export const labelStyle = { fontSize: '.72rem', color: 'var(--hp-gold)', fontFamily: 'var(--font-mono)', textTransform: 'uppercase', letterSpacing: '.08em', display: 'block', marginBottom: 5 };
export const inputStyle = { color: 'var(--hp-text)', background: 'var(--hp-surface)', width: '100%' };
export const th = { padding: '8px 10px', textAlign: 'left', fontSize: '.68rem', textTransform: 'uppercase', letterSpacing: '.06em', color: 'var(--hp-dim)', fontFamily: 'var(--font-mono)', whiteSpace: 'nowrap' };
export const td = { padding: '9px 10px', borderTop: '1px solid var(--hp-border)', fontSize: '.86rem', verticalAlign: 'middle' };
export const num = { textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' };
export const GREEN = 'var(--hp-green, #22c55e)';
export const AMBER = 'var(--hp-amber, #f59e0b)';
export const RED = 'var(--hp-red, #ef4444)';
